import { useEffect, useState } from 'react';

import apiFetch, { handleApiFetchError } from '@scale/frontend-lib/api-fetch';

export default function useInternalProject(projectId: string | null): [string | null] {
  const [internalProjectId, setInternalProjectId] = useState<string | null>(null);

  // Fetch the id of the internal project
  useEffect(() => {
    if (!projectId) return;

    setInternalProjectId(null);

    const signal = { aborted: false };

    apiFetch<any>(null, `corp-api/projects/${projectId}/internal_project_id`)
      .then(result => {
        if (signal.aborted) {
          return;
        }
        setInternalProjectId(result.id);
        return;
      })
      .catch(handleApiFetchError);

    return () => {
      signal.aborted = true;
    };
  }, [projectId]);

  return [internalProjectId];
}
